/**
 * Determines if the mentions dropdown should be shown based on the current cursor position and text
 * @param text The current text value
 * @param cursorPosition The current cursor position
 * @param enableUserMentions Whether user mentions are enabled
 * @returns boolean indicating if mentions dropdown should be shown
 */
export function shouldShowMentions(
  text: string,
  cursorPosition: number,
  enableUserMentions: boolean,
): boolean {
  if (!enableUserMentions) {
    return false;
  }

  const isAtSymbol = text[cursorPosition - 1] === '@';
  if (!isAtSymbol) {
    return false;
  }

  // Check if @ is at start of text, after space, or after newline
  return (
    cursorPosition === 1 || // Start of text
    text[cursorPosition - 2] === ' ' || // Space before @
    text[cursorPosition - 2] === '\n' // Newline before @
  );
}
